<p class="mt-4 pb-2 font-bold text-xs">
  {{ 'outlook.summary.appointment.title' | translate }}
</p>

@if (loading) {
  <maximizer-outlook-skeleton
    containerClasses="h-[120px] w-full rounded-md bg-neutral-25"
  ></maximizer-outlook-skeleton>
}

@if (!loading && !configuration.appointment) {
  <p class="text-body pb-8">
    {{ 'outlook.summary.appointment.emptyState' | translate }}
  </p>
}

@if (!loading && configuration.appointment) {
  <div class="text-xs space-y-2 mt-2">
    <div
      class="bg-white w-full rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around"
    >
      <div class="flex">
        <div class="flex-shrink-0 mr-2">
          <em
            class="fa-icons icon-solid icon-12 icon-calendar text-neutral-70"
          ></em>
        </div>
        <div class="flex-1 flex flex-col min-w-0">
          <span
            class="font-bold my-auto text-ellipsis overflow-hidden whitespace-nowrap mb-2"
          >
            {{ configuration.appointment.subject }}</span
          >

          <div class="flex">
            <span
              class="text-neutral-90 mr-1 text-ellipsis overflow-hidden whitespace-nowrap"
              >{{ 'outlook.summary.appointment.location' | translate }}:
            </span>
            <span class="text-neutral-70">{{
              configuration.appointment.location?.DisplayValue
            }}</span>
          </div>

          <div class="flex">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.appointment.time' | translate }}:
            </span>
            <span class="text-neutral-70">{{
              configuration.appointment.startDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>

          <div class="flex">
            <p class="text-neutral-70 line-clamp-3">
              <span class="text-neutral-90 mr-1"
                >{{
                  'outlook.summary.appointment.attendees' | translate
                }}: </span
              >{{ attendees.join(', ') }}
            </p>
          </div>

          <div
            class="text-neutral-70 line-clamp-3 overflow-hidden break-words min-w-0"
          >
            {{ configuration.appointment.description.DisplayValue }}
          </div>
        </div>
      </div>

      <div class="flex">
        <span class="ml-auto caption text-neutral-70 pt-1">{{
          configuration.appointment.creationDate
            | date: outlookStore.fullDateTimeFormat()
        }}</span>
      </div>
    </div>
    <div class="mb-2 flex items-center gap-2">
      <span class="text-neutral-70">
        {{ configuration.appointmentAmount }}
        {{ 'outlook.summary.appointment.amount' | translate }}
      </span>
      <a
        id="outlook-appointment-ui-summaryAppointment-more"
        class="underline text-link"
        [href]="deepLink()"
        target="_blank"
        rel="noopener"
        >{{ 'outlook.summary.openInMaximizer' | translate }}</a
      >
    </div>
  </div>
}
